import {
	locations, feast_locations, school_of_competence_locations,
	DEFAULT_FILTERS, DEFAULT_FEAST_FILTERS, DEFAULT_SCHOOL_OF_COMPETENCE_FILTERS,
} from '../views/constants';

export const ACCOUNT_ID = '12983a96-eee0-4769-a';
export const PAGE_SIZE = 12;
export const CUSTOM_FIELDS = {
	eventType: 863537,
	location: 872207,
	language: 872208,
	competence: 953792,
	schoolOfCompetenceLocation: 968725,
};

export const LANGUAGES = [
	{ value: 'English', code: 'en', labelKey: 'filters.language.en' },
	{ value: 'French', code: 'fr', labelKey: 'filters.language.fr' },
	{ value: 'Italian', code: 'it', labelKey: 'filters.language.it' },
	{ value: 'German', code: 'de', labelKey: 'filters.language.de' },
];

const SCHOOL_OF_COMPETENCE_LANGUAGES =LANGUAGES.filter(({ code }) => code !== 'it');

export const HOME_PORTAL = {
	name: 'Home',
	layout: 'home',
	fixedEventType: null,
	eventTypeOptions: [
		'Youngster',
		'Job Info Events',
		'Visits',
		'Recruitment Days (1d)',
		'Recruitment Days (1d+)',
	],
	locations,
	defaultFilters: DEFAULT_FILTERS,
	noEventsByType: {
		Visits: {
			i18nKey: 'noGuidedTours',
			link: 'https://www.skyguide.ch/guided-tours/request-guided-tour',
		},
	},
};

export const FEAST_PORTAL = {
	name: 'Feast',
	layout: 'dedicated',
	fixedEventType: 'FEAST',
	locations: feast_locations,
	defaultFilters: DEFAULT_FEAST_FILTERS,
	texts: {
		title: 'feast.title',
		subtitle: 'feast.subtitle',
		filterTitle: 'feast.filterTitle',
	},
	subtitleLink: 'https://jobs.skyguide.ch/search?locale=en_US',
};

export const SCHOOL_OF_COMPETENCE_PORTAL = {
	name: 'SchoolOfCompetence',
	layout: 'dedicated',
	fixedEventType: 'School of Competence',
	locations: school_of_competence_locations,
	locationFieldId: CUSTOM_FIELDS.schoolOfCompetenceLocation,
	multipleLocations: true,
	hideEventDates: true,
	contactEmail: 'peopleandlearning@skyguide.ch',
	languages: SCHOOL_OF_COMPETENCE_LANGUAGES,
	defaultFilters: {
		...DEFAULT_SCHOOL_OF_COMPETENCE_FILTERS,
		location: school_of_competence_locations.map(({ value }) => value),
		language: SCHOOL_OF_COMPETENCE_LANGUAGES.map(({ value }) => value),
	},
	texts: {
		title: 'schoolOfCompetence.title',
		subtitle: 'schoolOfCompetence.subtitle',
		filterTitle: 'schoolOfCompetence.filterTitle',
	},
	extraFilters: [
		{
			filterKey: 'competence',
			fieldId: CUSTOM_FIELDS.competence,
			labelKey: 'schoolOfCompetence.filterLabel',
			// Exact BO values: the API compares the text.
			options: [
				'Agile|Project|Change',
				'Copilot',
				'Human Factors',
				'Interpersonal Development',
				'Languages',
				'Leadership',
				'Lunchzeit',
				'MS365',
				'Safety & Security',
				'Wellbeing & Resilience',
				'Onboarding',
			],
		},
	],
};
